var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "18px",
    viewBox: "0 0 10 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "px-arrow-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Vimcar-\\u2013-Book-n-Drive-\\u2013-CleverShuttle-configuration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5j.-Already-reported-photo-1-\\u2013-full-view-mode-\\u2013-Vimcar-configuration",
    transform: "translate(-4.000000, -289.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prev-\\u2013-arrow",
    transform: "translate(-36.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7312972,27 L50,28.3125 L42.548,35.999 L50,43.6875 L48.7312972,45 L41.278,37.31 L41.2687028,37.3207446 L40,36.0082446 L40.008,36 L40,35.9917554 L41.2687028,34.6792554 L41.278,34.689 L48.7312972,27 Z",
    id: "px-arrow-left"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxArrowLeft);
export default __webpack_public_path__ + "static/media/px-arrow-left.d79aab5efd30b6b0448410eb56fc76e9.svg";
export { ForwardRef as ReactComponent };